import type { PaginatedResponse } from '../types/Games'

// The backend builds its pagination URLs from the internal host, so they must not reach the SSR payload.
export function toPaginatedResponse<T>({ data, meta }: PaginatedResponse<T>): PaginatedResponse<T> {
    return { data, meta: { current_page: meta.current_page, last_page: meta.last_page, total: meta.total } }
}
